var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74591 24.4115C2.77942 24.4115 2 23.6321 2 22.6656C2 22.2915 2.12471 21.9174 2.34295 21.6368L2.99766 20.7015L18.1185 0.28059C18.2432 0.124706 18.4302 0 18.6485 0C19.0226 0 19.3032 0.280594 19.3032 0.654717V0.717066V24.3804H3.74591V24.4115Z",
    fill: "#3ECF8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9225 15.5884C35.889 15.5884 36.6684 16.3678 36.6684 17.3343C36.6684 17.7084 36.5437 18.0825 36.3255 18.3631L35.6708 19.2984L20.55 39.7193C20.4253 39.8752 20.2382 39.9999 20.02 39.9999C19.6458 39.9999 19.3652 39.7193 19.3652 39.3452V39.2828V15.5884H34.9225Z",
    fill: "url(#paint0_linear_44917_7048)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9225 15.5884C35.889 15.5884 36.6684 16.3678 36.6684 17.3343C36.6684 17.7084 36.5437 18.0825 36.3255 18.3631L35.6708 19.2984L20.55 39.7193C20.4253 39.8752 20.2382 39.9999 20.02 39.9999C19.6458 39.9999 19.3652 39.7193 19.3652 39.3452V39.2828V15.5884H34.9225Z",
    fill: "url(#paint1_linear_44917_7048)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44917_7048",
    x1: 17.9898,
    y1: 24.0505,
    x2: 30.9024,
    y2: 29.0892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44917_7048",
    x1: 17.6745,
    y1: 10.1152,
    x2: 24.1203,
    y2: 21.4047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabase);
export default __webpack_public_path__ + "static/media/supabase.bbd8f1bb21ae60295029d52017d040a4.svg";
export { ForwardRef as ReactComponent };